import React, { FunctionComponent, useEffect } from 'react';
import BachelorIcon from 'assets/icons/bachelor_programs.svg';
import MasterIcon from 'assets/icons/master_programs.svg';

import { Link, useNavigate } from 'react-router-dom';
import styles from './ExploreSelector.module.scss';

const ExploreDegreeOptions: FunctionComponent = () => {
  return (
    <div
      className={`${styles.uaExploreSelect} z-9999 position-absolute top-0 start-0 bg-light w-100 h-100 d-flex flex-column justify-content-center align-items-center`}
    >
      <h2 className="fs-4">Which type of degree are you looking for?</h2>
      <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center">
        <Link
          to="/explore/bachelors"
          className="card col-12  m-3 col-sm-6 text-center shadow-sm animate__animated animate__fadeIn"
        >
          <img src={BachelorIcon} className="card-img-top" alt="Bachelor Degree" />
          <div className="card-body">
            <h5 className="card-title">Bachelor Degree</h5>
            <p className="card-text text-secondary">If you only have a high-school degree.</p>
            <button className="btn">Start Exploring →</button>
          </div>
        </Link>
        <Link
          to="/explore/masters"
          className="card m-3 col-12 col-sm-6 text-center shadow-sm animate__animated animate__fadeIn"
        >
          <img src={MasterIcon} className="card-img-top" alt="Master Degree" />
          <div className="card-body">
            <h5 className="card-title">Master Degree</h5>
            <p className="card-text text-secondary">
              To accelerate your career after already having a bachelor degree.
            </p>
            <button className="btn">Start Exploring →</button>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ExploreDegreeOptions;
